<template>
  <van-pull-refresh
    v-model="loading"
    @refresh="onRefresh"
    v-bind="vanPullRefreshProps"
    :class="empty&&'empty'"
  >
    <van-list
      v-model="loading"
      :finished="finished"
      @load="param[normalizer.pageNo]++"
      v-bind="VanListProps"
      :error.sync="isError"
    >
      <slot/>
      <div v-show="empty" style="height:100%">
        <slot name="empty"/>
      </div>

      <template #finished>
        <slot name="finished"/>
      </template>
      <template #error>
        <slot name="error"/>
      </template>
      <template #loading>
        <slot name="loading"/>
      </template>

    </van-list>

    <template #pulling>
      <slot name="pulling"/>
    </template>
    <template #loosing>
      <slot name="loosing"/>
    </template>
    <template #success>
      <slot name="success"/>
    </template>
    <template #normal>
      <slot name="normal"/>
    </template>
    <template #loading>
      <slot name="loading"/>
    </template>

  </van-pull-refresh>
</template>

<script>
import getPropByPath from '../../utils/getPropByPath'

export default {
  name: 'PullToRefresh',
  props: {
    param: {
      type: Object,
      default: () => ({})
    },
    normalizer: {
      type: Object,
      default: () => ({
        pageNo: 'pageNo',
        list: 'data.list',
        isLastPage: res => res.data && !res.data.hasNextPage
      })
    },
    listGetter: {
      type: Function,
      default: () => new Promise(resolve => resolve())
    },
    value: {
      type: Array,
      default: () => []
    },
    vanPullRefreshProps: {
      type: Object,
    },
    vanListProps: {
      type: Object,
    },
  },
  computed: {
    VanListProps () {
      return {
        finishedText: (this.$scopedSlots.empty && this.empty) ? '' : '没有更多啦',
        immediateCheck: false,
        errorText: '加载失败，点击重试',
        ...this.vanListProps,
      }
    },
    empty () {
      return this.finished && (!this.value || !this.value.length)
    }
  },
  watch: {
    param: {
      deep: true,
      handler (newVal) {
        // 非pageNo改变
        if (newVal[this.normalizer.pageNo] === this.pageNo__) {
          this.refreshing = true
          this.finished = false
          this.param[this.normalizer.pageNo] === 1 ? this.getList() : this.param[this.normalizer.pageNo] = 1
        }
        // pageNo自增时
        else if (newVal[this.normalizer.pageNo] !== 1) {
          this.getList()
        }
        this.pageNo__ = this.param[this.normalizer.pageNo]
      }
    }
  },
  data () {
    return {
      finished: false,
      loading: false,
      pageNo__: 1,
      refreshing: false,
      isError: false,
    }
  },
  created () {
    if (typeof this.normalizer.isLastPage !== 'function') {
      throw Error('[PullToRefresh] normalizer.isLastPage需为Function类型')
    }
    if (this.vanListProps?.immediateCheck === false) {
      return
    }
    this.getList()
  },
  methods: {
    onRefresh () {
      this.refreshing = true
      this.finished = false
      this.param[this.normalizer.pageNo] = 1
      this.getList()
    },
    getList () {
      this.loading = true
      this.listGetter().then(res => {
        const list = getPropByPath(res, this.normalizer.list)
        if (this.refreshing) {
          this.$emit('input', list || [])
          this.refreshing = false
        } else if (list && list.length) {
          this.$emit('input', this.value.concat(list))
        }
        this.finished = this.normalizer.isLastPage(res)
      }).catch(e => {
        this.isError = true
        if (this.refreshing) {
          this.$emit('input', [])
          this.refreshing = false
        }
      }).finally(e => {
        this.loading = false
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.van-pull-refresh.empty {
  height: 100%;

  .van-list {
    height: 100%;
  }
}
</style>
